import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";
import axios from "axios";

function MemberRquest() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [ratings, setRatings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    getRatings();
  }, []);

  const getRatings = async () => {
    try {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      const response = await axios.post(
        `${BASE_URL}/rating/get-rating-by-admin`,
        null,
        {
          params: { societyName },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setRatings(response.data);
    } catch (error) {
      console.error("Error fetching ratings:", error);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = ratings.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(ratings.length / itemsPerPage);

  return (
    <div className="app-container" style={styles.appContainer}>
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout" style={styles.mainLayout}>
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area" style={styles.contentArea}>
          <SubHeader />

          <div className="financial-container" style={styles.financialContainer}>
            {/* TABLE */}
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Employee</th>
                  <th style={styles.th}>Company</th>
                  <th style={styles.th}>Designation</th>
                  <th style={styles.th}>Member</th>
                  <th style={styles.th}>Unit No</th>
                  <th style={styles.th}>Rating</th>
                  <th style={styles.th}>Comment</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.map((item, index) => (
                  <tr
                    key={index}
                    style={styles.tr}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#f1f5f9")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "transparent")
                    }
                  >
                    <td style={styles.td}>{index + 1}</td>
                    <td style={styles.td}>{item.employeeName}</td>
                    <td style={styles.td}>{item.companyName}</td>
                    <td style={styles.td}>{item.designation}</td>
                    <td style={styles.td}>{item.memberName}</td>
                    <td style={styles.td}>{item.flatNo}</td>
                    <td style={{ ...styles.td, color: "#f59e0b", fontWeight: 600 }}>
                      {"★".repeat(item.star)}
                      {"☆".repeat(5 - item.star)}
                    </td>
                    <td style={styles.td}>{item.comment}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* PAGINATION */}
            <div style={styles.pagination}>
              <button
                style={
                  currentPage === 1
                    ? { ...styles.button, ...styles.buttonDisabled }
                    : styles.button
                }
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Prev
              </button>

              <span style={styles.pageText}>
                Page {currentPage} of {totalPages}
              </span>

              <button
                style={
                  currentPage === totalPages
                    ? { ...styles.button, ...styles.buttonDisabled }
                    : styles.button
                }
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default MemberRquest;

// INDUSTRIAL & ATTRACTIVE STYLES
const styles = {
  appContainer: {
    fontFamily: "Inter, sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
  },

  mainLayout: {
    display: "flex",
    flexDirection: "row",
  },

  contentArea: {
    flex: 1,
    padding: "20px 30px",
  },

  financialContainer: {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  },

  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    overflow: "hidden",
    fontSize: "14px",
  },

  th: {
    backgroundColor: "#007BFF",
    color: "#fff",
    textAlign: "left",
    padding: "12px 15px",
    fontWeight: "600",
    letterSpacing: "0.5px",
  },

  td: {
    padding: "12px 15px",
    borderBottom: "1px solid #e5e7eb",
    color: "#334155",
  },

  tr: {
    transition: "background 0.2s ease",
    cursor: "default",
  },

  pagination: {
    marginTop: "25px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
  },

  button: {
    padding: "8px 18px",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "#1e293b",
    color: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s ease",
  },

  buttonDisabled: {
    backgroundColor: "#cbd5f5",
    cursor: "not-allowed",
  },

  pageText: {
    fontWeight: "500",
    color: "#475569",
  },
};